import React, { Fragment } from 'react';
import styled from 'styled-components';

import checklist from '@front/common/src/assets/images/checklist.png';
import checklist2x from '@front/common/src/assets/images/checklist@2x.png';
import checklist3x from '@front/common/src/assets/images/checklist@3x.png';
import heartRelax from '@front/common/src/assets/images/heart-relax.png';
import heartRelax2x from '@front/common/src/assets/images/heart-relax@2x.png';
import heartRelax3x from '@front/common/src/assets/images/heart-relax@3x.png';
import piggyBank from '@front/common/src/assets/images/piggy-bank.png';
import piggyBank2x from '@front/common/src/assets/images/piggy-bank@2x.png';
import piggyBank3x from '@front/common/src/assets/images/piggy-bank@3x.png';

import { translate } from '@front/i18n';

import Modal, { ModalContent } from '@front/web-ui/src/components/modal/modal';
import StickerItem from '@front/web-ui/src/components/sticker-item/sticker-item';
import Separator from '@front/web-ui/src/components/separator/separator';
import Alert from '@front/web-ui/src/components/alert/alert';
import { useIsMobile } from '@front/web-ui/src/styles/media-queries';

const t = translate('screens.instant_tax_credit_selection.what_is_instant_tax_credit_modal');

const StyledModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
`;

const StyledAlert = styled(Alert)`
  margin-top: 20px;
`;

const Column = styled.div<{ $hasSmallGap: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
  padding-top: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
`;

type WhatIsInstantTaxCreditModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const images = () => ({
  you_pay_only_half: {
    alt: t('.items.you_pay_only_half.image_alt'),
    double: piggyBank2x,
    src: piggyBank,
    text: t('.items.you_pay_only_half.content'),
    title: t('.items.you_pay_only_half.title'),
    triple: piggyBank3x,
  },
  eligibility_is_simple: {
    alt: t('.items.eligibility_is_simple.image_alt'),
    text: t('.items.eligibility_is_simple.content'),
    double: checklist2x,
    src: checklist,
    title: t('.items.eligibility_is_simple.title'),
    triple: checklist3x,
  },
  in_practice: {
    alt: t('.items.in_practice.image_alt'),
    text: t('.items.in_practice.content'),
    double: heartRelax2x,
    src: heartRelax,
    title: t('.items.in_practice.title'),
    triple: heartRelax3x,
  },
});

const WhatIsInstantTaxCreditModal = ({ isOpen, onClose }: WhatIsInstantTaxCreditModalProps) => {
  const isMobile = useIsMobile();
  return (
    <Modal
      title={t('.title')}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        children: t('base.got_it'),
        onPress: onClose,
      }}
    >
      <StyledModalContent>
        <Column $hasSmallGap={isMobile}>
          {Object.entries(images()).map(([key, value]) => (
            <Fragment key={key}>
              <StickerItem {...value} />
              <Separator />
            </Fragment>
          ))}
        </Column>
        <StyledAlert type='info' content={t('.alert')} />
      </StyledModalContent>
    </Modal>
  );
};

export default WhatIsInstantTaxCreditModal;
